import { Zap, Star, TrendingUp } from 'lucide-react';

interface AdvertisementProps {
  className?: string;
  onAdClick?: () => void;
  postId?: string;
  postOwnerId?: string;
}

export default function Advertisement({ className = '', onAdClick }: AdvertisementProps) {
  const handleAdClick = () => {
    // Track ad click if needed
    console.log('Advertisement clicked');
    onAdClick?.();
  };

  return (
    <div 
      className={`relative w-full h-full bg-gradient-to-br from-[#065900] to-[#076a00] flex items-center justify-center cursor-pointer ${className}`}
      onClick={handleAdClick}
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="w-full h-full" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='4'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          backgroundRepeat: 'repeat'
        }}></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center text-white p-8 max-w-md">
        {/* Logo/Icon */}
        <div className="flex justify-center mb-6">
          <div className="bg-yellow-400 p-4 rounded-full">
            <Zap className="w-8 h-8 text-black" />
          </div>
        </div>

        {/* Headline */}
        <h2 className="text-2xl font-bold mb-4">
          Boost Your Reach
        </h2>

        {/* Subheading */}
        <p className="text-lg mb-6 opacity-90">
          Get 10x more views with MoZo Premium
        </p>

        {/* Features */}
        <div className="space-y-3 mb-8">
          <div className="flex items-center justify-center space-x-2">
            <Star className="w-5 h-5 text-yellow-400" />
            <span className="text-sm">Priority in feeds</span>
          </div>
          <div className="flex items-center justify-center space-x-2">
            <TrendingUp className="w-5 h-5 text-yellow-400" />
            <span className="text-sm">Advanced analytics</span>
          </div>
          <div className="flex items-center justify-center space-x-2">
            <Zap className="w-5 h-5 text-yellow-400" />
            <span className="text-sm">Unlimited uploads</span>
          </div>
        </div>

        {/* CTA Button */}
        <button 
          className="bg-yellow-400 hover:bg-yellow-500 text-black font-semibold px-8 py-3 rounded-full transition-colors duration-200 shadow-lg"
          onClick={(e) => {
            e.stopPropagation();
            handleAdClick();
          }}
        >
          Start Free Trial
        </button>

        {/* Small print */}
        <p className="text-xs opacity-70 mt-4">
          7-day free trial • Cancel anytime
        </p>
      </div>

      {/* Sponsored label */}
      <div className="absolute top-4 right-4 bg-black/30 text-white text-xs px-3 py-1 rounded-full">
        Sponsored
      </div>

      {/* Close button for accessibility */}
      <button 
        className="absolute top-4 left-4 text-white/70 hover:text-white text-sm"
        onClick={(e) => {
          e.stopPropagation();
          // Could implement skip ad functionality here
        }}
      >
        Skip Ad
      </button>
    </div>
  );
}
